import React from "react";
import { Container } from "react-bootstrap";
import { useIsMobile } from "../../utils/responsive";
export default function Banner3() {
  const isMobile = useIsMobile();
  return (
    <Container fluid className="p-0">
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}
        <div
          style={{
            width: isMobile ? "100%" : "90%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            // borderRight: "1px solid black",
            // borderLeft: "1px solid black",
            padding: isMobile ? "20px 40px" : "40px 150px",
            alignItems: "center",
          }}
        >
          <p className="body-lg m-0 text-center">
            <span className="accent-text">
              Emerging from her health journey&nbsp;
            </span>
            with renewed purpose, Kritika embraced entrepreneurship with the
            re-launch of House of December in 2021. Her signature projects span
            prestigious addresses such as DLF Aralias, Tatvam Villas, M3M Golf
            Estate, DLF Summit, and Sainik Farms, where she curates exclusive,
            handcrafted interiors tailored to the refined tastes of her
            clientele. Recognizing the demand for customized furnishings, she
            expanded into furniture manufacturing, creating a boutique workshop
            dedicated to artisanal craftsmanship.
          </p>
          <br />
          <br />
          <p className="body-lg m-0 text-center">
            Her battle with cancer fundamentally reshaped her design ethos,
            deepening her appreciation for the profound connection between
            interior spaces and well-being. This realization culminated in the
            co-founding of HomeGaatha, a pioneering platform that curates
            exceptional décor from undiscovered artisans and emerging brands. At
            HomeGaatha, Kritika blends heritage craftsmanship with contemporary
            design, redefining home styling by making it a deeply personal and
            emotionally resonant experience.
          </p>
        </div>
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
    </Container>
  );
}
